import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Row, Col } from "antd";
import {
	makeSelectFormulaByRowId,
	selectAllVisibleSectionsByCurrentPage,
} from "reducers";
import QuestionList from "./QuestionList";
import { arrayFromSize } from "utils/common";
import { Section } from "./QnaComponents";

const SectionParent = ({ children, section }) => {
	const { visible } = section;
	let calculatedVisibility = visible || true;
	let visibleFormulaId = visible?.formulaId;

	const selectVisibleFormulaValueById = makeSelectFormulaByRowId();
	const visibleFormulaValue = useSelector(
		(state) => selectVisibleFormulaValueById(state, visibleFormulaId),
		shallowEqual
	);

	if (typeof visible === "object" && visible !== null) {
		if (visibleFormulaId && visibleFormulaValue) {
			calculatedVisibility = visibleFormulaValue;
		} else calculatedVisibility = false;
	}

	return calculatedVisibility ? (
		<Section {...section}>{children}</Section>
	) : (
		<></>
	);
};

const SectionQuestionContainer = React.memo(
	({ sectionId, pageId, row, col, cols }) => {
		return (
			<QuestionList
				sectionId={sectionId}
				pageId={pageId}
				row={row}
				col={col}
				cols={cols}
			/>
		);
	}
);

/*
Important to memoise this container, as it receives the same
prop but selector returns a new object (with same values)
*/
const SectionContainer = ({ pageId }) => {
	const sections = useSelector(selectAllVisibleSectionsByCurrentPage);
	return sections.length > 0 ? (
		sections.map((s) => {
			let { rows, cols } = s;
			return (
				<SectionParent key={s.id} section={s}>
					{rows && cols ? (
						arrayFromSize(rows).map((r) => (
							<Row key={r}>
								{cols.map((c, index) => (
									<Col key={index} span={c.span}>
										{
											<SectionQuestionContainer
												key={`r${r}c${index}`}
												sectionId={s.id}
												pageId={s.pageId}
												row={r}
												col={index}
												cols={cols}
											/>
										}
									</Col>
								))}
							</Row>
						))
					) : (
						<SectionQuestionContainer
							sectionId={s.id}
							pageId={s.pageId}
						/>
					)}
				</SectionParent>
			);
		})
	) : (
		<p>
			There are no sections to fill out on this page. Please continue by
			clicking Next.
		</p>
	);
};

export default SectionContainer;
